export default __webpack_public_path__ + "static/11-ca63bff1d02376ac9c96046a0898004b.jpg";